export default "__VITE_ASSET__DzbIcRmq__"